import moment from "jalali-moment";

declare global {
  interface Date {
    formatTime(): string;
    getWeekDay(): string;
    toDateFormat(): Date;
    toShortGlobalString(): string;
    toLongPersianString(): string;
    toShortPersianString(): string;
    toShortPersianHumanString(): string;
  }

}

const months = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
const days = ["شنبه", "یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنج شنبه", "جمعه"];


// function compareDatesIgnoreTime(date1, date2) {
//   // Reset the time to midnight for both dates
//   const d1 = new Date(date1.setHours(0, 0, 0, 0));
//   const d2 = new Date(date2.setHours(0, 0, 0, 0));

//   // Compare the dates
//   return d1.getTime() === d2.getTime();
// }

Date.prototype.getWeekDay = function (): string {
  return this.toLocaleDateString("fa", { weekday: 'long' });
};

Date.prototype.toDateFormat = function (): Date {
  return new Date(this.toString());
};

Date.prototype.toShortGlobalString = function (): string {
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const day = String(this.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
};

// Date.prototype.toLongPersianString = function (): string {
//   console.log(this);
//   return `${this.toLocaleDateString("fa", { day: 'numeric' })} ${this.toLocaleDateString("fa", { month: 'long' })} ${this.toLocaleDateString("fa", { year: 'numeric' })} ${moment(this).format("HH:mm")}`.toPersianDigit()
// };

Date.prototype.toLongPersianString = function (): string {
  return `${this.toLocaleDateString("fa", { day: 'numeric' })} ${this.toLocaleDateString("fa", { month: 'long' })} ${this.toLocaleDateString("fa", { year: 'numeric' })}${moment(this).format("HH:mm")}`.toPersianDigit();
}

Date.prototype.toShortPersianString = function (): string {
  return `${this.toLocaleDateString("fa", { day: 'numeric' })} ${this.toLocaleDateString("fa", { month: 'long' })} ${this.toLocaleDateString("fa", { year: 'numeric' })}`.toPersianDigit();
}

Date.prototype.toShortPersianHumanString = function (): string {
  const date = new Date();
  const diff = (date.getTime() - this.getTime())/ 1000;
  if(diff < 60)
    return "هم اکنون";
  if(diff < 300)
    return "۵ دقیقه پیش";
  if(diff < 3600)
    return "۱ ساعت پیش";
  return `${this.toLocaleDateString("fa", { day: 'numeric' })} ${this.toLocaleDateString("fa", { month: 'long' })} ${this.toLocaleDateString("fa", { year: 'numeric' })}`.toPersianDigit();
}

Date.prototype.formatTime = function (): string {
  const hours = String(this.getHours()).padStart(2, '0');
  const minutes = String(this.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export default {};
